"use client";
import { Fragment, useEffect, useState } from "react";
import {
  NextButton,
  PrevButton,
} from "../../../../../components/new_components/buttonsFlow";
import { ReactComponent as GalileIcon } from "../../../../../public/logos/galilea-icono.svg";
import AnimationComponent from "../../../../../components/new_components/animation";
import StepInput from "../../../../../components/new_components/StepInput";
import OtpComponente from "../../../../../components/new_components/Otp";
import { KeyRound } from "lucide-react";
import { ProgressLinear } from "../../../../../components/progress/progressLinear";
import { useWindowSize } from "../../../helpers/bankDimensions";
import { stepsCreditStore } from "../../../../../store/creditStore/stepsCreditStore";
import { variablesGlobales } from "../../../../../configs/variables";
import axios from "axios";
import { normalizeMessage } from "../cardComponents/normalizeMessage";
import { useAlert } from "../provider/alertProvider";
import { CheckboxItem } from "../cardComponents/checkBoxItem";

const AutoAdvance = ({ onNext, delay }) => {
  useEffect(() => {
    const t = setTimeout(onNext, delay);
    return () => clearTimeout(t);
  }, [onNext, delay]);
  return null;
};

// ════════════════════════════════════════════════════════════════
// STEP 1 — Número de producto
// ════════════════════════════════════════════════════════════════
const Step1 = ({ onNext, onBack, isDesktop, product, setProduct }) => {
  const [error, setError] = useState("");

  const { height } = useWindowSize();

  const heightContainer =
    height < 700 ? "46dvh" : height <= 840 ? "65dvh" : "71dvh";

  let gapContainer =
    height < 700
      ? "25px"
      : height > 700 && height < 899
        ? "15px"
        : height > 900 && "60px";

  const handleChange = (e) => {
    const val = e.target.value
      .replace(/[^0-9]/g, "") // ← elimina TODO lo que no sea 0-9 (más estricto que \D)
      .slice(0, 10);

    if (val !== e.target.value.slice(0, 10)) return; // ← rechaza si hubo caracteres inválidos

    setProduct(val);
    if (error) setError("");
  };

  const handleKeyDownOnlyNumbers = (e) => {
    const allowed = [
      "Backspace",
      "Delete",
      "Tab",
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
    ];
    if (allowed.includes(e.key)) return;
    if (e.ctrlKey || e.metaKey) return;
    if (!/^[0-9]$/.test(e.key)) e.preventDefault();
  };

  const handleNext = () => {
    if (!/^3\d{9}$/.test(product)) {
      setError("Ingresa un número válido (10 dígitos, inicia en 3)");
      return;
    }
    onNext();
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minHeight: isDesktop ? "-webkit-fill-available" : heightContainer,
        paddingLeft: isDesktop ? "clamp(60px, 7vw, 80px)" : "0",
        paddingRight: isDesktop ? "clamp(60px, 7vw, 80px)" : "0",
        width: "100%",
        gap: "10px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: isDesktop ? gapContainer : "16px",
          flex: 1,
        }}
      >
        {/* Título */}
        <div>
          {isDesktop ? (
            <>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  flexWrap: "wrap",
                }}
              >
                <span
                  style={{
                    fontSize: "clamp(18px, 4vw, 40px)",
                    fontWeight: 800,
                    color: "#fff",
                  }}
                >
                  Conexión con
                </span>
                <img
                  src="/png/daviplata-blanco.png"
                  alt="Bancolombia"
                  style={{
                    maxWidth: "none",
                    height: "85px",
                    width: "200px",
                  }}
                />
              </div>
              <p
                style={{
                  color: "#9b93b8",
                  fontSize: "clamp(14px, 1.2vw, 18px)",
                  marginTop: "4px",
                }}
              >
                El número asociado a tu cuenta o producto donde recibes tu
                nómina.
              </p>
            </>
          ) : (
            <div className="flex justify-center">
              {" "}
              <img
                src="/png/daviplata-blanco.png"
                alt="Bancolombia"
                style={{
                  maxWidth: "none",
                  height: "90px",
                  width: "170px",
                }}
              />
            </div>
          )}
        </div>

        {/* ← Input de número de producto — usa tu componente aquí */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div style={{ width: isDesktop ? "400px" : "100%" }}>
            <StepInput
              name="product"
              value={product}
              maxLength={10}
              minLength={3}
              label="Número de producto"
              onChange={handleChange}
              onKeyDown={handleKeyDownOnlyNumbers}
              error={error}
              placeholder="3017138594"
              type="number"
              inputMode="numeric"
              required
              autoFocus
              isDesktop={isDesktop}
            />
          </div>
        </div>

        {/* Resumen de conexión */}
        <div className="flex justify-center">
          <div
            style={{
              background: "#565584",
              borderRadius: "14px",
              padding: isDesktop ? "20px 24px" : "14px 16px",
              display: "flex",
              flexDirection: "column",
              gap: isDesktop ? "14px" : "10px",
              width: isDesktop && "500px",
            }}
          >
            <span
              style={{ fontWeight: 700, color: "#E1DFE5", fontSize: "15px" }}
            >
              Resumen de conexión
            </span>
            {[
              "Recibirás una notificación en tu app Daviplata. Acéptala para generar un código.",
              "Digita el código generado en tu app Daviplata.",
              "Paga tu crédito de forma más rápida y segura.",
            ].map((text, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  gap: "10px",
                  alignItems: "flex-start",
                }}
              >
                {/* Check activo no manipulable */}
                <div
                  style={{
                    minWidth: "18px",
                    height: "18px",
                    borderRadius: "50%",
                    background: "rgb(41 33 79)",
                    flexShrink: 0,
                    marginTop: "2px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                    <path
                      d="M2 5l2.5 2.5L8 3"
                      stroke="#fff"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <span
                  style={{
                    color: "white",
                    fontSize: isDesktop ? "14px" : "13px",
                    lineHeight: "1.4",
                  }}
                >
                  {text}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Botones */}
      <div
        style={{
          display: "flex",
          justifyContent: isDesktop ? "flex-end" : "stretch",
        }}
      >
        <div
          style={{
            width: isDesktop ? "400px" : "-webkit-fill-available",
            display: "flex",
          }}
        >
          <PrevButton onBack={onBack} label="Atrás" isMobile={!isDesktop} />
          <NextButton
            onNext={handleNext}
            label="Continuar"
            isMobile={!isDesktop}
            disabled={!product}
          />
        </div>
      </div>
    </div>
  );
};

// ════════════════════════════════════════════════════════════════
// STEP 2 — OTP
// ════════════════════════════════════════════════════════════════
const Step2 = ({
  onNext,
  onBack,
  isDesktop,
  product,
  formDataOtp,
  setFormDataOtp,
}) => {
  const [viewProgress] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const [resendCount, setResendCount] = useState(0);
  const MAX_RESENDS = 1;

  const { height } = useWindowSize();

  const heightContainer =
    height < 700 ? "46dvh" : height <= 840 ? "65dvh" : "71dvh";

  let gapContainer =
    height < 700
      ? "30px"
      : height > 700 && height < 899
        ? "60px"
        : height > 900 && "120px";

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormDataOtp((prev) => ({ ...prev, [name]: value }));
  };

  const resendCodeSignature = () => {
    if (resendCount >= MAX_RESENDS) return;

    setResendCount((prev) => prev + 1);
    setDisableButton(true);
    setCountdown(60);

    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          // Si ya agotó los intentos, el botón queda deshabilitado permanentemente
          if (resendCount + 1 < MAX_RESENDS) {
            setDisableButton(false);
          }
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    // TODO: llamada real de reenvío aquí
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minHeight: isDesktop ? "-webkit-fill-available" : heightContainer,
        padding: isDesktop ? "0 80px" : "0",
        width: "100%",
        gap: "10px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: isDesktop ? gapContainer : "30px",
          flex: 1,
        }}
      >
        {/* Título */}
        {isDesktop ? (
          <div className="flex flex-col gap-3">
            <h2
              style={{
                fontSize: "clamp(28px, 4vw, 45px)",
                fontWeight: 800,
                color: "#fff",
                marginBottom: "8px",
                lineHeight: "1.2",
              }}
            >
              Te enviamos una notificación a tu app Daviplata.
            </h2>
            <p
              style={{
                color: "#9b93b8",
                fontSize: "20px",
                lineHeight: "1.5",
              }}
            >
              Entra a tu app Davipalata, acepta la notificación y genera el
              código.
            </p>
          </div>
        ) : (
          <div
            className="text-center"
            style={{ width: "300px", alignSelf: "center" }}
          >
            <p className="text-muted-foreground font-bold2 text-2xl">
              Te enviamos una notificación a tu app Daviplata.
            </p>
            {/* <p
              className="text-muted-foreground"
              style={{ fontSize: "14px", marginTop: "8px" }}
            >
              Escribe el código de 6 dígitos que te enviamos a tu WhatsApp
              registrado +57 {celularProtect}
            </p> */}
          </div>
        )}

        {/* OTP */}
        <div className="flex w-full justify-evenly">
          <div className="flex gap-3">
            <OtpComponente
              name="otp"
              id="otp"
              value={formDataOtp.otp}
              onChange={handleInputChange}
              isDesktop={isDesktop}
            ></OtpComponente>
          </div>
        </div>

        {/* Reenviar / Progress */}
        <div style={{ display: "flex", justifyContent: "center" }}>
          {viewProgress ? (
            <Fragment>
              <ProgressLinear />
              <p
                style={{ fontSize: 13, color: "#9b93b8", textAlign: "center" }}
              >
                Estamos validando tu código, por favor espera...
              </p>
            </Fragment>
          ) : (
            <button
              onClick={resendCodeSignature}
              type="button"
              disabled={disableButton || resendCount >= MAX_RESENDS}
              style={{
                height: isDesktop ? "56px" : "70px",
                backgroundColor: disableButton ? "#29214F" : "#565584",
                borderRadius: "50px",
                opacity: disableButton || resendCount >= MAX_RESENDS ? 0.5 : 1,
                cursor:
                  disableButton || resendCount >= MAX_RESENDS
                    ? "not-allowed"
                    : "pointer",
                border: disableButton ? "2px solid #687099" : "none",
                width: isDesktop ? "300px" : "100%",
                fontSize: isDesktop ? "18px" : "22px",
              }}
              className="flex items-center justify-center gap-3 px-4 py-3 transition-all duration-200 font-medium"
            >
              <KeyRound className="w-7 h-7" style={{ color: "#C9B8FF" }} />
              <p style={{ color: "#C9B8FF" }}>
                {resendCount >= MAX_RESENDS
                  ? "Sin intentos disponibles"
                  : countdown > 0
                    ? `Reenviar Notificación (${countdown}s)`
                    : "Reenviar Notificación"}
              </p>
            </button>
          )}
        </div>
      </div>

      {/* Botones */}
      <div
        style={{
          display: "flex",
          justifyContent: isDesktop ? "flex-end" : "stretch",
        }}
      >
        <div
          style={{
            width: isDesktop ? "400px" : "-webkit-fill-available",
            display: "flex",
          }}
        >
          <PrevButton onBack={onBack} label="Atrás" isMobile={!isDesktop} />
          <NextButton
            onNext={onNext}
            label="Continuar"
            isMobile={!isDesktop}
            disabled={formDataOtp.otp.length < 6}
          />
        </div>
      </div>
    </div>
  );
};

// ════════════════════════════════════════════════════════════════
// STEP 3 — Connecting animation
// ════════════════════════════════════════════════════════════════
const Step3 = ({ onNext, isDesktop }) => {
  const { width } = useWindowSize();

  const isMedium = isDesktop && width > 1600;
  return (
    <div
      className="flex flex-col w-full items-center"
      style={{
        paddingTop: "20px",
        paddingLeft: isDesktop ? "clamp(60px, 7vw, 80px)" : "0",
        paddingRight: isDesktop ? "clamp(60px, 7vw, 80px)" : "0",
        gap: isDesktop ? (isMedium ? "120px" : "80px") : "70px",
      }}
    >
      <style>{`
      @keyframes bounce {
        0%, 80%, 100% { transform: translateY(0); opacity: 0.4; }
        40% { transform: translateY(-10px); opacity: 1; }
      }
      @keyframes spin { to { transform: rotate(360deg); } }
    `}</style>

      <h2
        style={{
          color: "#fff",
          fontWeight: 800,
          fontSize: "clamp(20px, 3vw, 28px)",
          textAlign: "center",
          alignSelf: "flex-start",
        }}
      >
        Conectando tu cuenta de Daviplata
      </h2>

      {/* Logos + dots */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "16px",
          margin: "8px 0",
        }}
      >
        {/* Logo Galilea */}
        <GalileIcon
          style={{
            width: isDesktop ? (isMedium ? "180px" : "100px") : "80px",
            height: isDesktop ? (isMedium ? "110px" : "100px") : "80px",
          }}
          alt="Galilea"
        />

        {/* Dots animados */}
        <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
          {[0, 1, 2, 3].map((i) => (
            <div
              key={i}
              style={{
                width: isDesktop ? "14px" : "12px",
                height: isDesktop ? "14px" : "12px",
                borderRadius: "50%",
                backgroundColor: "white",
                animation: `bounce 1.2s ease-in-out ${i * 0.15}s infinite`,
                display: "flex",
                gap: "30px",
              }}
            />
          ))}
        </div>
        <img
          src="/png/daviplata-blanco.png"
          alt="Daviplata"
          style={{
            maxWidth: "none",
            height: isDesktop ? (isMedium ? "150px" : "100px") : "100px",
            width: isDesktop ? (isMedium ? "200px" : "150px") : "150px",
          }}
        />
      </div>

      {/* Card con checks */}
      <div
        style={{
          background: "#565584",
          borderRadius: "14px",
          padding: isDesktop ? "20px 24px" : "14px 16px",
          display: "flex",
          flexDirection: "column",
          gap: isDesktop ? "14px" : "10px",
        }}
      >
        {[
          "Seleccionarás la cuenta que deseas conectar.",
          "Paga tu crédito de forma más rápida y segura.",
          "Tus pagos se procesarán de forma segura.",
        ].map((text, i) => (
          <div
            key={i}
            style={{ display: "flex", gap: "10px", alignItems: "flex-start" }}
          >
            {/* Check activo no manipulable */}
            <div
              style={{
                minWidth: "18px",
                height: "18px",
                borderRadius: "50%",
                background: "rgb(41 33 79)",
                flexShrink: 0,
                marginTop: "2px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                <path
                  d="M2 5l2.5 2.5L8 3"
                  stroke="#fff"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <span
              style={{
                color: "white",
                fontSize: isDesktop ? "14px" : "13px",
                lineHeight: "1.4",
              }}
            >
              {text}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

// ════════════════════════════════════════════════════════════════
// STEP 4 — Todo listo para conectar (disclosure + checkboxes)
// ════════════════════════════════════════════════════════════════

const Step4 = ({ onNext, onBack, isDesktop }) => {
  const [accepted, setAccepted] = useState({ terms: true, data: true });
  const allAccepted = accepted.terms && accepted.data;

  const { width, height } = useWindowSize();

  const isMedium = isDesktop && width < 1600;

  const heightContainer =
    height < 700 ? "62dvh" : height <= 840 ? "65dvh" : "71dvh";

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: isDesktop ? "-webkit-fill-available" : heightContainer,
        padding: isDesktop ? "0 80px" : "0",
        width: "100%",
        gap: "10px",
        overflowY: "auto",
      }}
    >
      {/* Bloque superior */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: isDesktop ? (isMedium ? "15px" : "70px") : "25px",
          flex: 1,
        }}
      >
        {/* Título */}
        <div>
          <h2
            style={{
              fontSize: isDesktop ? "clamp(28px, 4vw, 40px)" : "22px",
              fontWeight: 800,
              color: "#fff",
              marginBottom: "4px",
            }}
          >
            Todo listo para conectar
          </h2>
          <p
            style={{
              color: "#9b93b8",
              fontSize: isDesktop ? "14px" : "12px",
              lineHeight: "1.4",
              margin: 0,
            }}
          >
            Al continuar, autorizas la conexión entre tu banco y Galilea. No
            almacenaremos tus claves ni datos sensibles.
          </p>
        </div>

        {/* Card banco seleccionado */}
        <div className="flex flex-col items-center">
          <div
            style={{
              background: isDesktop ? "rgb(26 24 48)" : "rgb(41, 33, 79)",
              borderRadius: "14px",
              padding: isDesktop ? "20px 24px" : "12px 16px",
              display: "flex",
              flexDirection: "column",
              gap: isDesktop ? "5px" : "8px",
              width: isDesktop ? "500px" : "350px",
            }}
          >
            <span
              style={{
                fontSize: "10px",
                fontWeight: 700,
                color: "#9b93b8",
                letterSpacing: "1.5px",
              }}
            >
              BANCO SELECCIONADO
            </span>
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div>
                {/* <p
                  style={{
                    color: "#fff",
                    fontWeight: 700,
                    fontSize: isDesktop ? "18px" : "15px",
                    margin: "0 0 2px",
                  }}
                >
                  Daviplata
                </p> */}
                <img
                  src="/png/daviplata-blanco.png"
                  alt="davipalta"
                  style={{
                    maxWidth: "none",
                    height: isDesktop ? (isMedium ? "45px" : "60px") : "60px",
                    width: isDesktop ? (isMedium ? "100px" : "150px") : "140px",
                  }}
                />
                <span
                  style={{
                    fontSize: "10px",
                    fontWeight: 700,
                    color: "#6fcf97",
                    letterSpacing: "1px",
                  }}
                >
                  PENDIENTE
                </span>
              </div>
            </div>
            <div
              style={{
                background: "#3d3870",
                borderRadius: "8px",
                padding: "8px 12px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <div
                style={{
                  minWidth: "18px",
                  height: "18px",
                  borderRadius: "50%",
                  background: "rgb(41 33 79)",
                  flexShrink: 0,
                  marginTop: "2px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path
                    d="M2 5l2.5 2.5L8 3"
                    stroke="#fff"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <span
                style={{
                  color: "#C9B8FF",
                  fontSize: isDesktop ? "13px" : "12px",
                }}
              >
                Tus pagos se procesarán de forma segura.
              </span>
            </div>
          </div>
        </div>

        {/* Aceptaciones */}
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <CheckboxItem
            checked={accepted.terms}
            onChange={() =>
              setAccepted((prev) => ({ ...prev, terms: !prev.terms }))
            }
          >
            Acepto haber leído{" "}
            <strong style={{ color: "#fff" }}>
              los reglamentos y políticas de privacidad
            </strong>{" "}
            para realizar pagos
          </CheckboxItem>

          <CheckboxItem
            checked={accepted.data}
            onChange={() =>
              setAccepted((prev) => ({ ...prev, data: !prev.data }))
            }
          >
            Acepto la{" "}
            <strong style={{ color: "#fff" }}>
              autorización para la administración de datos personales
            </strong>
          </CheckboxItem>
        </div>

        {/* Banner seguridad */}
        <div
          className="bg-purple"
          style={{
            borderRadius: "12px",
            padding: "12px 16px",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <div
            style={{
              flexShrink: 0,
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              background: "#2a2550",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <rect
                x="5"
                y="11"
                width="14"
                height="10"
                rx="2"
                stroke="white"
                strokeWidth="1.8"
              />
              <path
                d="M8 11V7a4 4 0 1 1 8 0v4"
                stroke="white"
                strokeWidth="1.8"
                strokeLinecap="round"
              />
              <circle cx="12" cy="16" r="1.5" fill="white" />
            </svg>
          </div>
          <p style={{ fontSize: "14px", margin: 0 }}>
            <span style={{ color: "white" }}>Tus credenciales </span>
            <span style={{ color: "white", fontWeight: 700 }}>
              nunca pasan{" "}
            </span>
            <span style={{ color: "white" }}>
              por nosotros. Todo es directamente con tu entidad bancaria.
            </span>
          </p>
        </div>
      </div>

      {/* Botones — siempre al fondo */}

      <div
        className="w-full gap-4"
        style={{
          display: "flex",
          justifyContent: isDesktop ? "flex-end" : "stretch",
        }}
      >
        <div
          style={{
            width: isDesktop ? "400px" : "-webkit-fill-available",
            display: "flex",
            justifyContent: isDesktop && "center",
          }}
        >
          <PrevButton onBack={onBack} label={"Atrás"} isMobile={!isDesktop} />
          <NextButton
            onNext={onNext}
            label={"Conectar"}
            isMobile={!isDesktop}
            showIconNext={true}
            disabled={!allAccepted}
          />
        </div>
      </div>
    </div>
  );
};

// ════════════════════════════════════════════════════════════════
// STEP 5 — Éxito
// ════════════════════════════════════════════════════════════════
const Step5 = ({ isDesktop, onComplete }) => {
  const { height } = useWindowSize();

  let heightCanvan = height < 750 ? "17rem" : height > 900 ? "25rem" : "20rem";
  let widthCanvan = height < 750 ? "15rem" : height > 900 ? "23rem" : "20rem";

  let heightContainer =
    height < 750 ? "19rem" : height > 900 ? "30rem" : "20rem";

  return (
    <div className="flex flex-col items-center justify-center">
      {/* Componente de animación Rive */}
      <h1
        className="font-bold2"
        style={{
          fontSize: "2rem",
          width: "300px",
          textAlign: "center",
        }}
      >
        ¡Luz Púrpura para Continuar!
      </h1>
      <AnimationComponent
        animationUrl="/animations/checkanimation.riv"
        width={heightCanvan}
        height={widthCanvan}
        heightContainer={heightContainer}
        isDesktop={isDesktop}
        stateMachines={["chek-animation"]}
      />
      <p
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "200px",
        }}
      >
        <span>
          ¡<span style={{ color: "#A68AFF" }}>Felicitaciones</span>!
        </span>
        <span
          style={{
            textAlign: "center",
          }}
        >
          Conexión segura realizada.
        </span>
      </p>
      <p
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <span
          style={{
            textAlign: "center",
          }}
        >
          Nos hemos conectado a tu banco de manera exitosa.
        </span>
      </p>
      <AutoAdvance onNext={onComplete} delay={3000} />
    </div>
  );
};

// ════════════════════════════════════════════════════════════════
// ORQUESTADOR
// ════════════════════════════════════════════════════════════════
const DaviplataFlow = ({
  bankValue,
  onComplete,
  onBack,
  isDesktop,
}) => {
  const [step, setStep] = useState(1);
  const [product, setProduct] = useState("");
  const [formDataOtp, setFormDataOtp] = useState({ otp: "" });

  const [, setTokenError] = useState(null);
  const [tokenIdWompi, setTokenIdWompi] = useState("");
  const [, setOtpWompi] = useState(0);

  const number_document = localStorage.getItem("doc");
  const customer_email = localStorage.getItem("email");
  const { stepCredit, saveSteps, loadSteps } = stepsCreditStore();
  const { showAlert } = useAlert();

  useEffect(() => {
    loadSteps();
  }, [loadSteps]);

  useEffect(() => {
    if (!stepCredit?.stepFlow) return;
    setStep(stepCredit.stepFlow);
  }, [stepCredit]);
  const next = () => {
    const nextStep = step + 1;
    setStep(nextStep);
    saveSteps({
      ...stepCredit,
      stepFlow: nextStep,
    });
  };

  const prev = () => {
    if (step === 1) {
      onBack();
    } else {
      let prevStep = 1;
      if (step === 4) prevStep = step - 2;
      if (step === 2) prevStep = step - 1;
      setStep(prevStep);
      saveSteps({
        ...stepCredit,
        stepFlow: prevStep,
      });
    }
  };

  // const validateTokenWompi = async () => {
  //   let payload = {
  //     doc: number_document,
  //   };

  //   try {
  //     const tokenSession = localStorage.getItem("token_jwt");

  //     const res = await axios.post(
  //       `${variablesGlobales.urlServiceBackend}/api/v1/tokenization/validate-tokenwompi`,
  //       payload,
  //       {
  //         headers: {
  //           authorization: `Bearer ${tokenSession}`,
  //         },
  //       },
  //     );
  //     if (res.data) {
  //       const data = res.data.data;
  //       if (data?.status === "PENDING") {
  //         showAlert(
  //           "info",
  //           normalizeMessage(
  //             "Tienes una solicitud de conexión pendiente con tu banco.",
  //           ),
  //           6000,
  //         );
  //         setTokenIdWompi(data?.id);
  //         setStep(3);
  //         saveSteps({ ...stepCredit, stepFlow: 3 });
  //       } else {
  //         setStep(1);
  //         saveSteps({ ...stepCredit, stepFlow: 1 });
  //       }
  //     }
  //   } catch (err) {
  //     const errorMsg = err?.response?.data?.message;
  //     showAlert("info", errorMsg, 8000);
  //     setTimeout(() => {
  //       setStep(1);
  //       saveSteps({ ...stepCredit, stepFlow: 1 });
  //     }, 5000);
  //   }
  // };

  const handleTokenize = async () => {
    setTokenError(null);

    // ← Explícito, no depende del closure de next()

    let payloadData = {
      type_document: "CC",
      product_number: product,
      customer_email,
      number_document,
    };

    let payload = {
      bankName: "daviplata",
      dataTokenization: payloadData,
    };

    try {
      const tokenSession = localStorage.getItem("token_jwt");

      const res = await axios.post(
        `${variablesGlobales.urlServiceBackend}/api/v1/tokenization/createTokenization`,
        payload,
        {
          headers: {
            authorization: `Bearer ${tokenSession}`,
          },
        },
      );

      const data = res.data;

      if (data?.status === "PENDING") {
        if (data?.message) {
          showAlert("info", normalizeMessage(data.message), 6000);
        }
        setTokenIdWompi(data?.id);

        console.log("Token Wompi:", data?.id);
        setStep(2);
        saveSteps({ ...stepCredit, stepFlow: 2 });
      } else {
        showAlert(
          "info",
          data?.message || "Error al conectar tu cuenta davipalta",
          8000,
        );
        setTimeout(() => {
          setStep(1);
          saveSteps({ ...stepCredit, stepFlow: 1 });
        }, 5000);
      }
    } catch (err) {
      const errorMsg = err?.response?.data?.message;
      console.error("Wompi error:", err?.response?.data);
      showAlert("info", errorMsg, 8000);
      setTimeout(() => {
        setStep(1);
        saveSteps({ ...stepCredit, stepFlow: 1 });
      }, 5000);
    }
  };

  const validateOTP = async () => {
    setTokenError(null);

    // ← Explícito, no depende del closure de next()

    try {
      if (formDataOtp.otp) {
        setOtpWompi(formDataOtp.otp);
        setTimeout(() => {
          setStep(5);
          saveSteps({ ...stepCredit, stepFlow: 5 });
        }, 3000);
      } else {
        showAlert("info", "Código generado invalido", 8000);
        setTimeout(() => {
          setStep(4);
          saveSteps({ ...stepCredit, stepFlow: 4 });
        }, 5000);
      }
    } catch (err) {
      showAlert("info", "Código invalido", 8000);
      setTimeout(() => {
        setStep(4);
        saveSteps({ ...stepCredit, stepFlow: 4 });
      }, 5000);
    }
  };

  const handlePaymentMethod = async () => {
    setTokenError(null);
    // ← Explícito, no depende del closure de next()
    if (!formDataOtp.otp) {
      showAlert("warning", "Por favor digita el código generado", 6000);
    }

    let payloadData = {
      code: formDataOtp.otp,
      id: tokenIdWompi,
    };

    let payload = {
      bankName: "daviplata",
      dataTokenization: payloadData,
    };

    try {
      const tokenSession = localStorage.getItem("token_jwt");

      const res = await axios.post(
        `${variablesGlobales.urlServiceBackend}/api/v1/tokenization/status`,
        payload,
        {
          headers: {
            authorization: `Bearer ${tokenSession}`,
          },
        },
      );

      setStep(3);
      saveSteps({ ...stepCredit, stepFlow: 3 });

      const data = res.data;

      if (data?.status === "AVAILABLE") {
        showAlert("info", normalizeMessage(data?.message), 6000);
        localStorage.setItem("tokenIdWompi", data?.id);
        setStep(4);
        saveSteps({ ...stepCredit, stepFlow: 4 });
      } else {
        showAlert(
          "info",
          data?.message || "Error al conectar tu cuenta davipalta",
          8000,
        );
        setTimeout(() => {
          setStep(2);
          saveSteps({ ...stepCredit, stepFlow: 2 });
        }, 5000);
      }
    } catch (err) {
      const errorMsg = err?.response?.data?.message;
      console.error("Wompi error:", err?.response?.data);
      showAlert("error", errorMsg, 8000);
      setTimeout(() => {
        setStep(2);
        saveSteps({ ...stepCredit, stepFlow: 2 });
      }, 5000);
    }
  };

  switch (step) {
    case 1:
      return (
        <Step1
          onNext={handleTokenize}
          onBack={prev}
          isDesktop={isDesktop}
          bank={bankValue}
          product={product}
          setProduct={setProduct}
        />
      );
    case 2:
      return (
        <Step2
          onNext={handlePaymentMethod}
          onBack={prev}
          isDesktop={isDesktop}
          bank={bankValue}
          product={product}
          formDataOtp={formDataOtp}
          setFormDataOtp={setFormDataOtp}
        />
      );
    case 3:
      return <Step3 onNext={next} isDesktop={isDesktop} bank={bankValue} />;
    case 4:
      return (
        <Step4
          onNext={validateOTP}
          onBack={prev}
          isDesktop={isDesktop}
          bank={bankValue}
        />
      );
    case 5:
      return (
        <Step5
          onComplete={onComplete({ phoneNumber: product })}
          isDesktop={isDesktop}
        />
      );
    default:
      return null;
  }
};

export default DaviplataFlow;
